import React from 'react';
import { StyleSheet,  View,Image, Text,TouchableOpacity } from 'react-native';

const Intro = ({onOpen}:{
  onOpen: () => void;
}) => {
  return <View style={styles.container}>
      <View  style={{...styles.logoW, backgroundColor: '#099b43'}}>
      <Image
        style={styles.logo}
        resizeMode="contain"
        resizeMethod="resize"
        source={require('../assets/logo.png')}
      />
    </View>
    <View  style={styles.containerw}>
    <Image
          style={{...styles.centerImage, width: '100%', height:811}}
          resizeMode="cover"
          resizeMethod="resize"
          source={require('../assets/cta.png')}
        />
          <View>
            <Text style={styles.text}>Începe provocarea Fuzetea!</Text>
          </View>

      <View>
                <TouchableOpacity
          style={styles.button}
          onPress={() => {
            onOpen();
          }}
        >
          <Text style={styles.buttonText}>Start</Text>
        </TouchableOpacity>
</View>
   
    </View>
    <View  style={styles.containerLast}>
        <Image
          style={{
            ...styles.centerImage,
            height: 74,
            width: 627
          }}
          resizeMode="contain"
          resizeMethod="resize"
          source={require('../assets/cups.png')}
        />
  
    </View>
  

  

  </View>
}

const styles = StyleSheet.create({
  container: {
    width:'100%',
    height:1200,
    backgroundColor: '#b8cd70',
  },
  logoW:{ },
    logo:{
    alignSelf: 'center',
    width: 800,
    height:126,
  },
  containerw:{
    position:'relative',
    width:'100%',
    zIndex: 1,
  },
  button:{
    backgroundColor:'#00a547',
    borderRadius: 7,
    alignSelf: 'center',
    height: 60,

    width:280,
    marginBottom:'6%',
    marginTop:'4%',
    alignItems:'center',
    justifyContent:'center',
  },
  text:{
    fontSize: 42,
    color: '#fff',
    fontWeight: 'bold',
    alignSelf: 'center',
    marginTop:'4%',
    paddingBottom:'0%',
    marginBottom:'1%',
    fontFamily: 'Agriculture',

  },
  centerImage:{
    alignSelf: 'center',
  },
  buttonText: {
    color: '#fff',
    fontSize: 32,
    fontFamily: 'Agriculture',
        fontWeight: "bold",
    textAlign: 'center',
    lineHeight: 60,
  },
  containerLast:{
    backgroundColor:'#b8cd70',
     width:'100%',
     flex:1,
     flexDirection: 'column',
     paddingTop: '0%',
     height: 196,
     marginTop: '1%',
 },
   
});
export default  Intro;
